import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import ProductItem from "./ProductItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_PRODUCTS, ON_NEW_PRODUCT, ON_UPDATED_PRODUCT} from "../../../queries/inventory";
import update from "immutability-helper";
import "./ProductsList.css";

class ProductsList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToNewProducts(this.props, {}); 
    this.props.subscribeToProductUpdates(this.props, {}); 
  }

  render() {
    let {loading, error, products} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "SKU",
      "Title",
      "Bundled"
    ])
    return (
      <Table 
        extraClassName="ProductsList"
        data={fromJS(products)} 
        renderer={ProductItem} 
        tableHeader={tableHeader}
        onItemClick={this.handleItemClick.bind(this)}
        selected={this.props.selectedProductId}
        mode="table"
        itemKey="sku"
        />
    )
  }

  handleItemClick(itemData, e) {
    let id = itemData.get("sku");
    this.props.onSelectionChange(id, itemData.get("type"));
  }  
}


const mapDispatchToProps = dispatch => ({
  subscribeToNewProducts: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_PRODUCT,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          products: {
            $push: [subscriptionData.data.newProduct]
          }
        })
      }
    })
  },
  subscribeToProductUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_PRODUCT,
      updateQuery: (prev, { subscriptionData }) => {
        return prev;
        // if (!subscriptionData.data) {
        //   return prev;
        // }
        // return update(prev, {
        //   products: {
        //     $merge: [subscriptionData.data.updatedProduct]
        //   }
        // })
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_PRODUCTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      type: props.productFilter
    }
  })
})

export default withQuery(withSubscription(ProductsList));